import React from 'react';
import { customModal } from '@src/mobile/components/ModalBox';
import Input from './Input';

export const showInput = ({ replyName, callback }) => {
    const maxSize = 200;
    const config = {
        placeholder: replyName ? `回复${replyName}` : '请输入友善的评论',
        maxSize,
        limit: maxSize,
        additional: ['emoji'],
    };

    customModal(Input, { callback, config });
};
